<template>
	<div class="pagination-az" :style="$vuetify.breakpoint.width < 720 ? heightPaginacaoStyle : ''">
		<div class="align-center d-flex">
			<slot name="pagination-actions"></slot>
			<div v-if="totalPaginas > 1" class="custom-pagination">
				<v-btn icon dense small :disabled="page <= 1" class="chevron-btn" @click="emitirEventoUpdatePage(page - 1)">
					<v-icon>mdi-chevron-left</v-icon>
				</v-btn>
				<v-btn
					v-for="(pageNumber, index) in paginasVisiveis"
					:key="`page-${index}`"
					:class="{ 'active-page': pageNumber === page, ellipsis: pageNumber === '...' }"
					dense
					small
					text
					@click="emitirEventoUpdatePage(pageNumber)"
				>
					{{ pageNumber }}
				</v-btn>
				<v-btn icon dense small :disabled="page >= totalPaginas" class="chevron-btn" @click="emitirEventoUpdatePage(page + 1)">
					<v-icon>mdi-chevron-right</v-icon>
				</v-btn>
			</div>
		</div>
		<v-spacer v-if="totalPaginas <= 1"></v-spacer>
		<div class="az-select-pagination" :class="{ 'not-show-items-per-page': !showItemsPerPage }">
			<div v-if="totalItens > 0" class="pr-5 total-itens">
				{{ startAndStopPage }}
			</div>
			<div v-if="showItemsPerPage" id="itemsPerPage" class="align-center align-content-center d-flex justify-center">
				<span>Linhas por página:</span>
				<v-select
					id="selectItemsPerPage"
					:value="itemsPerPage"
					:items="linhasPorPagina"
					dense
					@input="$emit('update-items-per-page', $event)"
				></v-select>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'paginacao-tabela',
	props: {
		itemsPerPage: {
			type: Number,
			required: true,
		},
		linhasPorPagina: {
			type: Array,
			default() {
				return [10, 25, 50, 100]
			},
		},
		page: {
			type: Number,
			required: true,
		},
		totalVisibleMidOdd: {
			type: Number,
			default: 3,
		},
		totalItens: {
			type: Number,
			required: true,
		},
		totalPaginas: {
			type: Number,
			required: true,
		},
		showItemsPerPage: {
			type: Boolean,
		},
	},
	computed: {
		heightPaginacaoStyle() {
			return {
				height: `${this.totalPaginas > 1 ? '105px' : '50px'}`,
			}
		},
		startAndStopPage() {
			const totalItensPage = this.page * this.itemsPerPage
			const totalItensStart = (this.page - 1) * this.itemsPerPage + 1
			const totalItensStop = totalItensPage > this.totalItens ? this.totalItens : totalItensPage
			return `${totalItensStart} - ${totalItensStop} de ${this.totalItens}`
		},
		paginasVisiveis() {
			if (this.totalPaginas <= this.totalVisibleMidOdd) {
				return this.gerarListaSimplesDePaginas()
			}

			return this.gerarListaPaginada()
		},
	},
	methods: {
		gerarListaSimplesDePaginas() {
			return Array.from({ length: this.totalPaginas }, (_, i) => i + 1)
		},
		gerarListaPaginada() {
			const paginas = []
			const metadeVisivel = Math.floor(this.totalVisibleMidOdd / 2)

			paginas.push(1)

			if (this.page > metadeVisivel + 2) {
				paginas.push('...')
			}

			const paginaInicial = Math.max(2, this.page - metadeVisivel)
			const paginaFinal = Math.min(this.totalPaginas - 1, this.page + metadeVisivel)

			for (let i = paginaInicial; i <= paginaFinal; i++) {
				paginas.push(i)
			}

			if (this.page + metadeVisivel < this.totalPaginas - 1) {
				paginas.push('...')
			}

			paginas.push(this.totalPaginas)

			return paginas
		},
		emitirEventoUpdatePage(numeroPagina) {
			if (this.ehPaginaValida(numeroPagina)) {
				this.$emit('update-page', numeroPagina)
			}
		},
		ehPaginaValida(numeroPagina) {
			return numeroPagina !== '...' && numeroPagina >= 1 && numeroPagina <= this.totalPaginas
		},
	},
}
</script>

<style lang="stylus" scoped>
.custom-pagination
	display flex
	gap 6px
	align-items center

.v-btn
	height 28px !important
	width 38px !important
	min-width 38px !important
	background #fff !important
	color #000 !important
	font-size 13px !important
	border-radius 4px !important
	border 1px solid #ccc !important
	transition .3s cubic-bezier(0,0,.2,1)
	text-decoration none
	box-shadow none !important

.active-page
	background-color #0067a5 !important
	color white !important
	border none

.chevron-btn
	background none !important
	color var(--v-primary-base) !important
	border none !important
	box-shadow none !important
	padding 0 !important
	width 24px !important
	min-width 24px !important

.pagination-az
	display -webkit-box
	display -ms-flexbox
	display flex
	-webkit-box-pack justify
	-ms-flex-pack justify
	justify-content space-between
	font-size 13px

	.az-select-pagination
		-webkit-box-align center
		-ms-flex-align center
		align-items center
		display -webkit-box
		display -ms-flexbox
		display flex
		color #777

		span
			color #777
			margin-right 10px

		.v-select
			font-size 13px
			max-width 80px

		.v-select__selection--comma
			font-size 13px
			margin 10px 5px 5px 0 !important

	.not-show-items-per-page
		height 60px

	.v-icon
		font-size: 24px !important
		color: var(--v-primary-base)

.ellipsis
	background none !important
	color rgba(0, 0, 0, 0.87) !important
	border none !important
	box-shadow none !important
	cursor default !important
	pointer-events none !important

@media (max-width: 720px)
	.pagination-az
		.az-select-pagination
			width 100%
			justify-content space-around
			flex-wrap wrap

		.paginacao-tabela
			display flex
			justify-content center

	.not-show-items-per-page
		height 40px
</style>
